import React, { useState } from 'react';
import { Button, FormGroup, Modal } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { assignPatientBranch, changePatientBranch } from '../../../api/protocol';
import { HandleApiError } from '../../../components/Notifications/APIErrorHandler';
import { Success } from '../../../components/Notifications/Notifications';
import { useBranches } from './useBranches';

export const AssignBranchModal = ({ isShowing, hide, protocolId, numberInProtocol, isChange, onSuccess }) => {
    const { t } = useTranslation();
    const [branches] = useBranches(protocolId);
    const [selectedBranchId, setSelectedBranchId] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    if (!isShowing) return null;

    const handleSubmit = async () => {
        if (!selectedBranchId) return;
        setIsSubmitting(true);
        try {
            if (isChange) {
                await changePatientBranch(protocolId, numberInProtocol, parseInt(selectedBranchId, 10));
                Success('protocolNotifications.branch_Changed');
            } else {
                await assignPatientBranch(protocolId, numberInProtocol, parseInt(selectedBranchId, 10));
                Success('protocolNotifications.branch_Assigned');
            }
            onSuccess && onSuccess();
            hide();
        } catch (error) {
            HandleApiError(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const title = isChange
        ? t('protocols.branches.changeBranch')
        : t('protocols.branches.assignBranch');

    return ReactDOM.createPortal(
        <Modal show onHide={hide} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormGroup>
                    <label className="control-label">{t('protocols.branches.selectBranch')}</label>
                    <select
                        className="form-control"
                        value={selectedBranchId}
                        onChange={e => setSelectedBranchId(e.target.value)}
                    >
                        <option value="">{t('protocols.branches.selectBranchPlaceholder')}</option>
                        {branches.map(branch => (
                            <option key={branch.id} value={branch.id}>{branch.name}</option>
                        ))}
                    </select>
                </FormGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={hide} disabled={isSubmitting}>{t('buttons.cancel')}</Button>
                <Button
                    bsStyle="primary"
                    disabled={isSubmitting || !selectedBranchId}
                    onClick={handleSubmit}
                >
                    {t('buttons.confirm')}
                </Button>
            </Modal.Footer>
        </Modal>,
        document.body
    );
};
